import { useTranslation } from "react-i18next";

/**
 * AbandonedScreen — 未受検 (abandoned) にされた respondent への案内画面 (ADR-0054 Decision 3)。
 */
export function AbandonedScreen() {
  const { t } = useTranslation("respond");
  return (
    <section className="space-y-6">
      <header className="space-y-1">
        <h2 className="text-base font-semibold">{t("abandoned.title")}</h2>
        <p className="text-sm text-muted-foreground">{t("abandoned.description")}</p>
      </header>
    </section>
  );
}
